import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations
import en from '../locales/en.json'
import el from '../locales/el.json'

const resources = {
  en: {
    translation: en
  },
  el: {
    translation: el
  }
}

// Configure i18n but don't initialize yet - we'll do that in main.tsx
const i18nInstance = i18n
  .use(LanguageDetector)
  .use(initReactI18next)

// Create the initialization function
i18nInstance.init({
  resources,
  fallbackLng: 'en',
  lng: localStorage.getItem('i18nextLng') || 'en',
  debug: false,
  
  react: {
    useSuspense: false
  },
  
  interpolation: {
    escapeValue: false
  },
  
  detection: {
    order: ['localStorage', 'navigator', 'htmlTag'],
    caches: ['localStorage']
  }
})

export default i18nInstance
